
    import * as React from 'react';

    const SocialX20 = ({ color = 'currentcolor', height = '20px', width = '20px', ...rest }) => {
      const svgStyle: React.CSSProperties = {...{"position":"absolute","top":"0","right":"0","bottom":"0","left":"0","width":"100%","height":"100%"}, fill: color};

      return (
        <div style={{ ...{"position":"relative"}, height, width }} { ...rest }>
          <svg viewBox="0 0 20 20" fill="none" style={svgStyle}><g clipPath="url(#Social_X_20_svg__clip0_5054_698)"><path d="M11.1428 9.08175L15.6108 4H14.5524L10.6712 8.41151L7.5736 4H4L8.6852 10.6716L4 16H5.0584L9.1544 11.3403L12.4264 16H16M5.4404 4.78095H7.0664L14.5516 15.2574H12.9252" /></g><defs><clipPath id="Social_X_20_svg__clip0_5054_698"><rect width={12} height={12} fill="white" transform="translate(4 4)" /></clipPath></defs></svg>
        </div>
      );
    };

    SocialX20.displayName = 'SocialX20';

    export default SocialX20;
  